<template>
  <section class="dp-layout">
    <section class="dp-right op-page">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Integration control</div>
        <h3 class="op-page__title">合作方开放配置</h3>
        <p class="op-page__desc">统一管理学校开放能力、合作方凭证、资源边界与回调通道。学校总闸仅在机构管理维护。</p>
      </div>
      <div>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openCreate">开通</el-button>
        <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
      </div>
    </header>

    <div class="toolbar-filter-bar">
    <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
      <div class="toolbar-filter-fields">
      <el-form-item label="学校名称">
        <el-input v-model="filters.schoolName" clearable placeholder="支持模糊搜索" class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="学校编号">
        <el-input v-model="filters.schoolDepartmentId" clearable placeholder="可选，精确匹配" class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      </div>
    </el-form>
    </div>

    <div class="tbl-scroll-host">
    <el-table :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无合作方应用"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column label="学校" min-width="190" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="op-name">{{ scope.row.SchoolName || '—' }}</div>
          <div class="op-sub op-mono">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="接入状态" min-width="150">
        <template slot-scope="scope">
          <div class="op-status-stack">
            <span class="op-readiness" :class="{ 'is-ready': scope.row.IsSyncTb && scope.row.TbThirdPartId > 0 }">
              {{ scope.row.IsSyncTb && scope.row.TbThirdPartId > 0 ? '天波已就绪' : '天波未就绪' }}
            </span>
            <span :class="scope.row.IsEnabled ? 'is-ok' : 'is-bad'">{{ scope.row.IsEnabled ? '应用启用' : '应用停用' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="应用标识" min-width="178" show-overflow-tooltip>
        <template slot-scope="scope"><span class="op-mono">{{ scope.row.AppKey }}</span></template>
      </el-table-column>
      <el-table-column label="回调通道" min-width="150">
        <template slot-scope="scope">
          <div class="op-status-stack">
            <span :class="scope.row.DoorRecordCallbackEnabled ? 'is-ok' : 'op-readiness'">通行{{ scope.row.DoorRecordCallbackEnabled ? '开启' : '关闭' }}</span>
            <span :class="scope.row.DoorDeviceStatusCallbackEnabled ? 'is-ok' : 'op-readiness'">设备{{ scope.row.DoorDeviceStatusCallbackEnabled ? '开启' : '关闭' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="LastAccessTime" label="最近调用" width="160" />
      <el-table-column label="操作" width="88" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openManage(scope.row)">管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        :total="total" style="float: right" @current-change="load" />
    </el-col>

    <!-- 开通 -->
    <el-dialog title="开通合作方" :visible.sync="createVisible" width="520px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="选择学校">
          <el-select v-model="createSchoolId" filterable clearable placeholder="输入学校名称搜索" style="width:100%">
            <el-option v-for="s in eligibleSchools" :key="s.SchoolId"
              :label="schoolOptionLabel(s)"
              :value="s.SchoolId" :disabled="s.HasEnabledPartner" />
          </el-select>
       </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="creating" @click="doCreate">开通</el-button>
      </div>
    </el-dialog>

    <!-- 密钥一次性展示 -->
    <el-dialog title="请妥善保存应用密钥" :visible.sync="secretVisible" width="560px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <el-alert type="warning" :closable="false" title="关闭后无法再次查看明文密钥，请立即复制保存。" style="margin-bottom:12px" />
      <el-form label-width="100px" size="small">
        <el-form-item label="应用标识"><el-input :value="secretInfo.appKey" readonly /></el-form-item>
        <el-form-item label="应用密钥"><el-input :value="secretInfo.appSecret" readonly /></el-form-item>
        <el-form-item label="学校编号"><el-input :value="secretInfo.schoolId" readonly /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="secretVisible = false">我已保存</el-button>
      </div>
    </el-dialog>

    <!-- 接入信息 -->
    <el-dialog title="接入信息" :visible.sync="accessVisible" width="560px" custom-class="op-detail-dialog">
      <el-form v-if="accessInfo" label-width="110px" size="small">
        <el-form-item label="接口根地址"><el-input :value="accessInfo.ApiBaseUrl" readonly /></el-form-item>
        <el-form-item label="学校编号"><el-input :value="accessInfo.SchoolId" readonly /></el-form-item>
        <el-form-item label="应用标识"><el-input :value="accessInfo.AppKey" readonly /></el-form-item>
        <el-form-item label="凭证版本"><span>{{ accessInfo.CredentialVersion }}</span></el-form-item>
        <el-form-item label="状态"><span>{{ accessInfo.IsEnabled ? '启用' : '停用' }}</span></el-form-item>
      </el-form>
    </el-dialog>

    <!-- 回调配置 -->
    <el-dialog title="配置回调" :visible.sync="callbackVisible" width="640px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <el-form label-width="140px" size="small">
        <el-form-item label="通行记录地址">
          <el-input v-model="callbackForm.DoorRecordCallbackUrl" placeholder="HTTPS；本机联调可用 http://127.0.0.1:端口/路径" />
        </el-form-item>
        <el-form-item label="启用通行回调">
          <el-switch v-model="callbackForm.DoorRecordCallbackEnabled" />
          <el-button type="text" style="margin-left:12px" @click="sendTest('doorRecord')">发送测试</el-button>
        </el-form-item>
        <el-form-item label="设备状态地址">
          <el-input v-model="callbackForm.DoorDeviceStatusCallbackUrl" placeholder="HTTPS；本机联调可用 http://127.0.0.1:端口/路径" />
        </el-form-item>
        <el-form-item label="启用设备回调">
          <el-switch v-model="callbackForm.DoorDeviceStatusCallbackEnabled" />
          <el-button type="text" style="margin-left:12px" @click="sendTest('doorDeviceStatus')">发送测试</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="callbackVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingCallback" @click="saveCallback">保存</el-button>
      </div>
    </el-dialog>

    <!-- 应用资源范围 -->
    <el-dialog title="应用资源范围" :visible.sync="scopesVisible" width="620px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <el-alert type="info" :closable="false" style="margin-bottom:12px"
        :title="scopeLoading ? '正在读取学校资源上限…' : `应用只能在「${scopeSchoolName || '当前学校'}」允许的范围内继续收窄。`" />
      <div v-loading="scopeLoading" class="op-switch-grid">
        <div v-for="item in resourceOptions" :key="item.key" class="op-switch-card">
          <div>
            <div class="op-switch-card__name">{{ item.label }}</div>
            <div class="op-switch-card__desc">
              {{ schoolScopeLimits[item.key] === false ? '学校层已关闭，应用不可开启' : item.desc }}
            </div>
          </div>
          <el-switch v-model="scopesForm[item.key]" :disabled="scopeLoading || schoolScopeLimits[item.key] === false" />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="scopesVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingScopes" :disabled="scopeLoading" @click="saveScopes">保存资源范围</el-button>
      </div>
    </el-dialog>

    <!-- 学校天波配置 -->
    <el-dialog title="学校开放能力" :visible.sync="schoolCfgVisible" width="680px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <template v-if="schoolCfgForm">
        <div class="op-config-summary">
          <div class="op-config-summary__item">
            <span class="op-config-summary__label">学校</span>
            <span class="op-config-summary__value">{{ schoolCfgForm.SchoolName }}</span>
          </div>
          <div class="op-config-summary__item">
            <span class="op-config-summary__label">天波组织 ID</span>
            <span class="op-config-summary__value op-mono">{{ schoolCfgForm.TbThirdPartId || '尚未绑定' }}</span>
          </div>
          <div class="op-config-summary__item">
            <span class="op-config-summary__label">天波对接（仅机构管理可改）</span>
            <span :class="schoolCfgForm.IsSyncTb ? 'is-ok' : 'is-bad'">
              {{ schoolCfgForm.IsSyncTb ? '已启用天波对接' : '未启用天波对接' }}
            </span>
          </div>
          <div class="op-config-summary__item">
            <span class="op-config-summary__label">出站状态</span>
            <span :class="schoolCfgForm.IsTbReady ? 'is-ok' : 'is-warn'">
              {{ schoolCfgForm.IsTbReady ? '可调用天波' : '当前不可出站' }}
            </span>
          </div>
        </div>
        <el-alert v-if="!schoolCfgForm.IsSyncTb" type="warning" :closable="false" show-icon
          title="未启用天波对接：手工同步、旁路推送和规则下发不会出站。开放平台接入由此页独立开关控制。" style="margin-bottom:14px" />

        <div class="op-dialog-section-title">通道能力</div>
        <div class="op-switch-grid">
          <div v-for="item in capabilityOptions" :key="item.key" class="op-switch-card">
            <div>
              <div class="op-switch-card__name">{{ item.label }}</div>
              <div class="op-switch-card__desc">{{ item.desc }}</div>
            </div>
            <el-switch v-model="schoolCfgForm[item.key]" />
          </div>
        </div>

        <div class="op-dialog-section-title">学校资源上限</div>
        <div class="op-switch-grid">
          <div v-for="item in resourceOptions" :key="item.key" class="op-switch-card">
            <div>
              <div class="op-switch-card__name">{{ item.label }}</div>
              <div class="op-switch-card__desc">{{ item.desc }}</div>
            </div>
            <el-switch v-model="schoolCfgForm[item.key]" />
          </div>
        </div>
        <el-form label-width="70px" size="small" style="margin-top:16px">
          <el-form-item label="备注"><el-input v-model.trim="schoolCfgForm.Remarks" maxlength="200" show-word-limit /></el-form-item>
        </el-form>
      </template>
      <div slot="footer">
        <el-button @click="schoolCfgVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingSchoolCfg" @click="saveSchoolCfg">保存学校能力</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="manageRow ? (manageRow.SchoolName || '应用管理') : '应用管理'"
      :visible.sync="manageVisible" width="640px" custom-class="op-config-dialog">
      <div v-if="manageRow" class="op-manage">
        <div class="op-manage__meta">
          <span class="op-mono">{{ manageRow.AppKey }}</span>
          <span :class="manageRow.IsEnabled ? 'is-ok' : 'is-bad'">{{ manageRow.IsEnabled ? '应用启用' : '应用停用' }}</span>
        </div>
        <div class="op-dialog-section-title">配置</div>
        <div class="op-manage__grid">
          <button type="button" class="op-manage__item" @click="fromManage(showAccess)">
            <b>接入信息</b>
            <span>查看接口地址、学校编号和应用标识</span>
          </button>
          <button type="button" class="op-manage__item" @click="fromManage(openSchoolTbConfig)">
            <b>学校能力</b>
            <span>开放接入、手工同步、旁路与资源上限</span>
          </button>
          <button type="button" class="op-manage__item" @click="fromManage(openCallback)">
            <b>回调配置</b>
            <span>通行记录与设备状态回调地址</span>
          </button>
          <button type="button" class="op-manage__item" @click="fromManage(openScopes)">
            <b>资源范围</b>
            <span>该应用可写的部门、学生、教师等资源</span>
          </button>
        </div>
        <div class="op-dialog-section-title">凭证与状态</div>
        <div class="op-manage__grid">
          <button type="button" class="op-manage__item" @click="fromManage(confirmReset)">
            <b>重置密钥</b>
            <span>旧令牌立即失效，新密钥只展示一次</span>
          </button>
          <button type="button" class="op-manage__item" @click="fromManage(manageRow.IsEnabled ? confirmDisable : confirmEnable)">
            <b>{{ manageRow.IsEnabled ? '停用应用' : '启用应用' }}</b>
            <span>{{ manageRow.IsEnabled ? '停用后合作方无法换 Token 和写入' : '重新允许该应用接入' }}</span>
          </button>
          <button type="button" class="op-manage__item is-danger op-manage__item--wide" @click="fromManage(confirmDelete)">
            <b>删除应用</b>
            <span>删除后不可恢复，请确认学校不再使用该凭证</span>
          </button>
        </div>
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getPartnerOpenAppPage,
  getPartnerEligibleSchools,
  getPartnerAccessInfo,
  createPartnerOpenApp,
  resetPartnerOpenSecret,
  disablePartnerOpenApp,
  enablePartnerOpenApp,
  deletePartnerOpenApp,
  updatePartnerCallback,
  updatePartnerOpenAppScopes,
  sendPartnerTestCallback,
  getSchoolTbConfig,
  saveSchoolTbConfig
} from '@/api/modules/openPlatform';

export default {
  name: 'PartnerConfig',
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      filters: { schoolDepartmentId: '', schoolName: '' },
      createVisible: false,
      creating: false,
      createSchoolId: '',
      eligibleSchools: [],
      secretVisible: false,
      secretInfo: {},
      accessVisible: false,
      accessInfo: null,
      callbackVisible: false,
      savingCallback: false,
      callbackForm: {
        Id: 0,
        DoorRecordCallbackUrl: '',
        DoorDeviceStatusCallbackUrl: '',
        DoorRecordCallbackEnabled: true,
        DoorDeviceStatusCallbackEnabled: true
      },
      scopesVisible: false,
      savingScopes: false,
      scopeLoading: false,
      scopeSchoolName: '',
      schoolScopeLimits: {},
      scopesForm: {
        Id: 0,
        AllowDept: true,
        AllowStudent: true,
        AllowStaff: true,
        AllowParent: true,
        AllowDevice: true,
        AllowAccessRule: true
      },
      capabilityOptions: [
        { key: 'EnableManualBasicSync', label: '手工基础同步', desc: '允许运营批量同步部门与人员' },
        { key: 'EnableOpenPlatform', label: '开放平台接入', desc: '允许合作方开应用、拿 Token、调开放 API；与机构管理「启用天波对接」独立' },
        { key: 'EnableAccessRulePush', label: '后台规则下发', desc: '允许平台后台下发门禁规则' },
        { key: 'EnableBizSidePush', label: '业务旁路推送', desc: '允许请假、学生等业务顺带推送' }
      ],
      resourceOptions: [
        { key: 'AllowDept', label: '部门', desc: '组织架构与班级层级' },
        { key: 'AllowStudent', label: '学生', desc: '学生基本信息' },
        { key: 'AllowStaff', label: '教师', desc: '教职工基本信息' },
        { key: 'AllowParent', label: '家长', desc: '监护人与学生关系' },
        { key: 'AllowDevice', label: '设备', desc: '门禁设备信息' },
        { key: 'AllowAccessRule', label: '门禁规则', desc: '主规则及子规则' }
      ],
      schoolCfgVisible: false,
      savingSchoolCfg: false,
      schoolCfgForm: null,
      manageVisible: false,
      manageRow: null
    };
  },
  created() {
    this.load();
  },
  methods: {
    handleSearch() {
      this.page = 1;
      this.load();
    },
    load() {
      this.loading = true;
      const params = { page: this.page, pageSize: this.pageSize };
      if (this.filters.schoolDepartmentId) params.schoolDepartmentId = this.filters.schoolDepartmentId;
      if (this.filters.schoolName) params.schoolName = this.filters.schoolName.trim();
      getPartnerOpenAppPage(params).then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.tableData = page.data || [];
          this.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => { this.loading = false; });
    },
    openCreate() {
      this.createSchoolId = '';
      this.createVisible = true;
      getPartnerEligibleSchools().then(res => {
        if (res.data && res.data.success) this.eligibleSchools = res.data.response || [];
      });
    },
    schoolOptionLabel(s) {
      const name = s.SchoolName || '';
      if (s.HasEnabledPartner) return name + '（已开通）';
      if (!s.EnableOpenPlatform) return name;
      return name;
    },
    doCreate() {
      if (!this.createSchoolId) {
        this.$message.warning('请选择学校');
        return;
      }
      this.$confirm('确认开通该校合作方应用？应用密钥仅展示一次。若该校尚未打开开放平台接入，将一并打开。', '二次确认', { type: 'warning' })
        .then(() => {
          this.creating = true;
          return createPartnerOpenApp(this.createSchoolId);
        })
        .then(res => {
          this.creating = false;
          if (res.data && res.data.success) {
            this.createVisible = false;
            this.secretInfo = res.data.response || {};
            this.secretVisible = true;
            this.load();
          } else {
            this.$message.error((res.data && res.data.msg) || '开通失败');
          }
        })
        .catch(() => { this.creating = false; });
    },
    openManage(row) {
      this.manageRow = row;
      this.manageVisible = true;
    },
    fromManage(handler) {
      const row = this.manageRow;
      this.manageVisible = false;
      this.$nextTick(() => {
        if (row && typeof handler === 'function') handler(row);
      });
    },
    showAccess(row) {
      getPartnerAccessInfo(row.Id).then(res => {
        if (res.data && res.data.success) {
          this.accessInfo = res.data.response;
          this.accessVisible = true;
        } else {
          this.$message.error((res.data && res.data.msg) || '获取失败');
        }
      });
    },
    openCallback(row) {
      this.callbackForm = {
        Id: row.Id,
        DoorRecordCallbackUrl: row.DoorRecordCallbackUrl || '',
        DoorDeviceStatusCallbackUrl: row.DoorDeviceStatusCallbackUrl || '',
        DoorRecordCallbackEnabled: !!row.DoorRecordCallbackEnabled,
        DoorDeviceStatusCallbackEnabled: !!row.DoorDeviceStatusCallbackEnabled
      };
      this.callbackVisible = true;
    },
    saveCallback() {
      this.savingCallback = true;
      updatePartnerCallback(this.callbackForm).then(res => {
        this.savingCallback = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '已保存');
          this.callbackVisible = false;
          this.load();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => { this.savingCallback = false; });
    },
    openScopes(row) {
      this.scopeSchoolName = row.SchoolName || '';
      this.schoolScopeLimits = {};
      this.scopesForm = {
        Id: Number(row.Id),
        AllowDept: row.AllowDept !== false,
        AllowStudent: row.AllowStudent !== false,
        AllowStaff: row.AllowStaff !== false,
        AllowParent: row.AllowParent !== false,
        AllowDevice: row.AllowDevice !== false,
        AllowAccessRule: row.AllowAccessRule !== false
      };
      this.scopesVisible = true;
      this.scopeLoading = true;
      getSchoolTbConfig(row.SchoolId).then(res => {
        if (res.data && res.data.success) {
          const config = res.data.response || {};
          this.resourceOptions.forEach(item => {
            this.$set(this.schoolScopeLimits, item.key, config[item.key] !== false);
            if (config[item.key] === false) this.scopesForm[item.key] = false;
          });
        } else {
          this.$message.error((res.data && res.data.msg) || '读取学校资源上限失败');
        }
      }).catch(() => {
        this.$message.error('读取学校资源上限失败');
      }).finally(() => {
        this.scopeLoading = false;
      });
    },
    saveScopes() {
      this.savingScopes = true;
      updatePartnerOpenAppScopes(this.scopesForm).then(res => {
        this.savingScopes = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '已保存');
          this.scopesVisible = false;
          this.load();
        } else this.$message.error((res.data && res.data.msg) || '保存失败');
      }).catch(() => { this.savingScopes = false; });
    },
    openSchoolTbConfig(row) {
      getSchoolTbConfig(row.SchoolId).then(res => {
        if (res.data && res.data.success) {
          this.schoolCfgForm = Object.assign({}, res.data.response || {});
          this.schoolCfgVisible = true;
        } else this.$message.error((res.data && res.data.msg) || '加载配置失败');
      });
    },
    saveSchoolCfg() {
      if (!this.schoolCfgForm) return;
      this.savingSchoolCfg = true;
      const payload = {
        SchoolDepartmentId: Number(this.schoolCfgForm.SchoolDepartmentId),
        EnableManualBasicSync: !!this.schoolCfgForm.EnableManualBasicSync,
        EnableOpenPlatform: !!this.schoolCfgForm.EnableOpenPlatform,
        EnableAccessRulePush: !!this.schoolCfgForm.EnableAccessRulePush,
        EnableBizSidePush: !!this.schoolCfgForm.EnableBizSidePush,
        AllowDept: !!this.schoolCfgForm.AllowDept,
        AllowStudent: !!this.schoolCfgForm.AllowStudent,
        AllowStaff: !!this.schoolCfgForm.AllowStaff,
        AllowParent: !!this.schoolCfgForm.AllowParent,
        AllowDevice: !!this.schoolCfgForm.AllowDevice,
        AllowAccessRule: !!this.schoolCfgForm.AllowAccessRule,
        Remarks: this.schoolCfgForm.Remarks || ''
      };
      saveSchoolTbConfig(payload).then(res => {
        this.savingSchoolCfg = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '已保存');
          this.schoolCfgVisible = false;
          this.load();
        } else this.$message.error((res.data && res.data.msg) || '保存失败');
      }).catch(() => { this.savingSchoolCfg = false; });
    },
    sendTest(eventType) {
      sendPartnerTestCallback({ Id: this.callbackForm.Id, EventType: eventType }).then(res => {
        if (res.data && res.data.success) this.$message.success(res.data.response || res.data.msg || '已发送');
        else this.$message.error((res.data && res.data.msg) || '发送失败');
      });
    },
    confirmReset(row) {
      this.$confirm('重置后旧令牌立即失效，新应用密钥仅展示一次。确认？', '二次确认', { type: 'warning' })
        .then(() => resetPartnerOpenSecret(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.secretInfo = res.data.response || {};
            this.secretVisible = true;
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '重置失败');
        })
        .catch(() => {});
    },
    confirmDisable(row) {
      this.$confirm('停用后将拒绝新请求并吊销令牌。确认？', '二次确认', { type: 'warning' })
        .then(() => disablePartnerOpenApp(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已停用');
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '操作失败');
        })
        .catch(() => {});
    },
    confirmEnable(row) {
      this.$confirm('确认重新启用该合作方应用？', '二次确认', { type: 'warning' })
        .then(() => enablePartnerOpenApp(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已启用');
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '操作失败');
        })
        .catch(() => {});
    },
    confirmDelete(row) {
      const name = row.SchoolName || row.SchoolId || '';
      this.$confirm(
        `删除后列表不再显示，令牌立即失效；历史日志与映射仍保留。确认删除「${name}」的合作方应用？`,
        '二次确认',
        { type: 'warning' }
      )
        .then(() => deletePartnerOpenApp(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已删除');
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '删除失败');
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.op-manage__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
}
.op-manage__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.op-manage__item {
  display: block;
  min-height: 72px;
  padding: 12px 14px;
  text-align: left;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font: inherit;
  color: inherit;
}
.op-manage__item--wide {
  grid-column: 1 / -1;
}
.op-manage__item:hover {
  border-color: #c6d4ee;
  background: #f5f8fc;
}
.op-manage__item b {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.op-manage__item span {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.op-manage__item.is-danger b {
  color: #f56c6c;
}
@media (max-width: 768px) {
  .op-manage__grid {
    grid-template-columns: 1fr;
  }
}
</style>
